var cov_1283wwoyq = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/Tree.tsx",
      hash = "c51c1a23f6a667f44456a6d9ba42654a04adb0ed",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/Tree.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      },
      "2": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 33
        }
      },
      "3": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "4": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 56,
          column: 8
        }
      },
      "5": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 48
        }
      },
      "6": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 52
        }
      },
      "7": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 58
        }
      },
      "8": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 44
        }
      },
      "9": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 60
        }
      },
      "10": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 48
        }
      },
      "11": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 83
        }
      },
      "12": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 74
        }
      },
      "13": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 67
        }
      },
      "14": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 20
        }
      },
      "15": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "16": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 46
        }
      },
      "17": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "18": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 42
        }
      },
      "19": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "20": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 39
        }
      },
      "21": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 100
        }
      },
      "22": {
        start: {
          line: 79,
          column: 48
        },
        end: {
          line: 79,
          column: 100
        }
      },
      "23": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 106
        }
      },
      "24": {
        start: {
          line: 80,
          column: 71
        },
        end: {
          line: 80,
          column: 106
        }
      },
      "25": {
        start: {
          line: 85,
          column: 23
        },
        end: {
          line: 85,
          column: 33
        }
      },
      "26": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 60
        }
      },
      "27": {
        start: {
          line: 90,
          column: 19
        },
        end: {
          line: 90,
          column: 43
        }
      },
      "28": {
        start: {
          line: 91,
          column: 21
        },
        end: {
          line: 91,
          column: 70
        }
      },
      "29": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 94,
          column: 5
        }
      },
      "30": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 39
        }
      },
      "31": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 74
        }
      },
      "32": {
        start: {
          line: 100,
          column: 26
        },
        end: {
          line: 100,
          column: 36
        }
      },
      "33": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 40
        }
      },
      "34": {
        start: {
          line: 101,
          column: 19
        },
        end: {
          line: 101,
          column: 40
        }
      },
      "35": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 30
        }
      },
      "36": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 25
        }
      },
      "37": {
        start: {
          line: 119,
          column: 17
        },
        end: {
          line: 119,
          column: 34
        }
      },
      "38": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 122,
          column: 5
        }
      },
      "39": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 38
        }
      },
      "40": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      "41": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 37
        }
      },
      "42": {
        start: {
          line: 132,
          column: 32
        },
        end: {
          line: 132,
          column: 42
        }
      },
      "43": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 137,
          column: 5
        }
      },
      "44": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 136,
          column: 8
        }
      },
      "45": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 29
        }
      },
      "46": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 140,
          column: 5
        }
      },
      "47": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 48
        }
      },
      "48": {
        start: {
          line: 144,
          column: 35
        },
        end: {
          line: 144,
          column: 45
        }
      },
      "49": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 150,
          column: 5
        }
      },
      "50": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 20
        }
      },
      "51": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 12
        }
      },
      "52": {
        start: {
          line: 151,
          column: 24
        },
        end: {
          line: 151,
          column: 33
        }
      },
      "53": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 156,
          column: 5
        }
      },
      "54": {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 53
        }
      },
      "55": {
        start: {
          line: 153,
          column: 44
        },
        end: {
          line: 153,
          column: 52
        }
      },
      "56": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 40
        }
      },
      "57": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 39
        }
      },
      "58": {
        start: {
          line: 157,
          column: 18
        },
        end: {
          line: 157,
          column: 39
        }
      },
      "59": {
        start: {
          line: 161,
          column: 28
        },
        end: {
          line: 161,
          column: 38
        }
      },
      "60": {
        start: {
          line: 162,
          column: 20
        },
        end: {
          line: 162,
          column: 42
        }
      },
      "61": {
        start: {
          line: 163,
          column: 19
        },
        end: {
          line: 163,
          column: 47
        }
      },
      "62": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 164,
          column: 35
        }
      },
      "63": {
        start: {
          line: 164,
          column: 29
        },
        end: {
          line: 164,
          column: 35
        }
      },
      "64": {
        start: {
          line: 165,
          column: 22
        },
        end: {
          line: 165,
          column: 62
        }
      },
      "65": {
        start: {
          line: 166,
          column: 17
        },
        end: {
          line: 208,
          column: 6
        }
      },
      "66": {
        start: {
          line: 167,
          column: 22
        },
        end: {
          line: 167,
          column: 27
        }
      },
      "67": {
        start: {
          line: 169,
          column: 35
        },
        end: {
          line: 169,
          column: 43
        }
      },
      "68": {
        start: {
          line: 170,
          column: 19
        },
        end: {
          line: 170,
          column: 20
        }
      },
      "69": {
        start: {
          line: 171,
          column: 6
        },
        end: {
          line: 179,
          column: 8
        }
      },
      "70": {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 178,
          column: 9
        }
      },
      "71": {
        start: {
          line: 173,
          column: 10
        },
        end: {
          line: 173,
          column: 51
        }
      },
      "72": {
        start: {
          line: 175,
          column: 10
        },
        end: {
          line: 175,
          column: 21
        }
      },
      "73": {
        start: {
          line: 176,
          column: 10
        },
        end: {
          line: 176,
          column: 49
        }
      },
      "74": {
        start: {
          line: 176,
          column: 29
        },
        end: {
          line: 176,
          column: 49
        }
      },
      "75": {
        start: {
          line: 177,
          column: 10
        },
        end: {
          line: 177,
          column: 24
        }
      },
      "76": {
        start: {
          line: 181,
          column: 23
        },
        end: {
          line: 181,
          column: 28
        }
      },
      "77": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 193,
          column: 8
        }
      },
      "78": {
        start: {
          line: 183,
          column: 8
        },
        end: {
          line: 192,
          column: 9
        }
      },
      "79": {
        start: {
          line: 184,
          column: 10
        },
        end: {
          line: 184,
          column: 39
        }
      },
      "80": {
        start: {
          line: 185,
          column: 15
        },
        end: {
          line: 192,
          column: 9
        }
      },
      "81": {
        start: {
          line: 187,
          column: 10
        },
        end: {
          line: 187,
          column: 22
        }
      },
      "82": {
        start: {
          line: 188,
          column: 10
        },
        end: {
          line: 190,
          column: 11
        }
      },
      "83": {
        start: {
          line: 189,
          column: 12
        },
        end: {
          line: 189,
          column: 23
        }
      },
      "84": {
        start: {
          line: 191,
          column: 10
        },
        end: {
          line: 191,
          column: 31
        }
      },
      "85": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 205,
          column: 7
        }
      },
      "86": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 44
        }
      },
      "87": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 71
        }
      },
      "88": {
        start: {
          line: 197,
          column: 48
        },
        end: {
          line: 197,
          column: 71
        }
      },
      "89": {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 198,
          column: 37
        }
      },
      "90": {
        start: {
          line: 199,
          column: 8
        },
        end: {
          line: 199,
          column: 48
        }
      },
      "91": {
        start: {
          line: 200,
          column: 23
        },
        end: {
          line: 200,
          column: 47
        }
      },
      "92": {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 44
        }
      },
      "93": {
        start: {
          line: 201,
          column: 20
        },
        end: {
          line: 201,
          column: 44
        }
      },
      "94": {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 203,
          column: 48
        }
      },
      "95": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 54
        }
      },
      "96": {
        start: {
          line: 207,
          column: 6
        },
        end: {
          line: 207,
          column: 18
        }
      },
      "97": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 211,
          column: 5
        }
      },
      "98": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 210,
          column: 53
        }
      },
      "99": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 26
        }
      },
      "100": {
        start: {
          line: 244,
          column: 8
        },
        end: {
          line: 244,
          column: 18
        }
      },
      "101": {
        start: {
          line: 245,
          column: 21
        },
        end: {
          line: 245,
          column: 61
        }
      },
      "102": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 279,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 49
          },
          end: {
            line: 67,
            column: 3
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        },
        loc: {
          start: {
            line: 69,
            column: 60
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 69
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 14
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 84
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 37
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 89
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 14
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 99
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        },
        loc: {
          start: {
            line: 104,
            column: 49
          },
          end: {
            line: 112,
            column: 3
          }
        },
        line: 104
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 114,
            column: 3
          }
        },
        loc: {
          start: {
            line: 114,
            column: 31
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 114
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        },
        loc: {
          start: {
            line: 118,
            column: 44
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 118
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        loc: {
          start: {
            line: 125,
            column: 38
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 125
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 131,
            column: 2
          },
          end: {
            line: 131,
            column: 3
          }
        },
        loc: {
          start: {
            line: 131,
            column: 52
          },
          end: {
            line: 141,
            column: 3
          }
        },
        line: 131
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 134,
            column: 36
          },
          end: {
            line: 134,
            column: 37
          }
        },
        loc: {
          start: {
            line: 134,
            column: 42
          },
          end: {
            line: 136,
            column: 7
          }
        },
        line: 134
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 143,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        loc: {
          start: {
            line: 143,
            column: 33
          },
          end: {
            line: 158,
            column: 3
          }
        },
        line: 143
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 153,
            column: 39
          },
          end: {
            line: 153,
            column: 40
          }
        },
        loc: {
          start: {
            line: 153,
            column: 44
          },
          end: {
            line: 153,
            column: 52
          }
        },
        line: 153
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 73
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 160
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 166,
            column: 35
          },
          end: {
            line: 166,
            column: 36
          }
        },
        loc: {
          start: {
            line: 166,
            column: 44
          },
          end: {
            line: 208,
            column: 5
          }
        },
        line: 166
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 169,
            column: 35
          },
          end: {
            line: 169,
            column: 36
          }
        },
        loc: {
          start: {
            line: 169,
            column: 41
          },
          end: {
            line: 169,
            column: 43
          }
        },
        line: 169
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 171,
            column: 32
          },
          end: {
            line: 171,
            column: 33
          }
        },
        loc: {
          start: {
            line: 171,
            column: 42
          },
          end: {
            line: 179,
            column: 7
          }
        },
        line: 171
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 176,
            column: 23
          },
          end: {
            line: 176,
            column: 24
          }
        },
        loc: {
          start: {
            line: 176,
            column: 29
          },
          end: {
            line: 176,
            column: 49
          }
        },
        line: 176
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 182,
            column: 31
          },
          end: {
            line: 182,
            column: 32
          }
        },
        loc: {
          start: {
            line: 182,
            column: 41
          },
          end: {
            line: 193,
            column: 7
          }
        },
        line: 182
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 191,
            column: 23
          },
          end: {
            line: 191,
            column: 24
          }
        },
        loc: {
          start: {
            line: 191,
            column: 29
          },
          end: {
            line: 191,
            column: 31
          }
        },
        line: 191
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 214,
            column: 2
          },
          end: {
            line: 214,
            column: 3
          }
        },
        loc: {
          start: {
            line: 214,
            column: 72
          },
          end: {
            line: 216,
            column: 3
          }
        },
        line: 214
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 218,
            column: 2
          },
          end: {
            line: 218,
            column: 3
          }
        },
        loc: {
          start: {
            line: 218,
            column: 11
          },
          end: {
            line: 280,
            column: 3
          }
        },
        line: 218
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 56,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 17
          }
        }, {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 56,
            column: 8
          }
        }],
        line: 45
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 26
          }
        }, {
          start: {
            line: 52,
            column: 30
          },
          end: {
            line: 52,
            column: 48
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 53,
            column: 18
          },
          end: {
            line: 53,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 53,
            column: 57
          },
          end: {
            line: 53,
            column: 71
          }
        }, {
          start: {
            line: 53,
            column: 74
          },
          end: {
            line: 53,
            column: 83
          }
        }],
        line: 53
      },
      "3": {
        loc: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 38
          }
        }, {
          start: {
            line: 54,
            column: 42
          },
          end: {
            line: 54,
            column: 66
          }
        }],
        line: 54
      },
      "4": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }],
        line: 70
      },
      "5": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 73
      },
      "6": {
        loc: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }, {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }],
        line: 77
      },
      "7": {
        loc: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 27
          }
        }, {
          start: {
            line: 77,
            column: 31
          },
          end: {
            line: 77,
            column: 48
          }
        }, {
          start: {
            line: 77,
            column: 52
          },
          end: {
            line: 77,
            column: 74
          }
        }],
        line: 77
      },
      "8": {
        loc: {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 79,
            column: 100
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 79,
            column: 100
          }
        }, {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 79,
            column: 100
          }
        }],
        line: 79
      },
      "9": {
        loc: {
          start: {
            line: 79,
            column: 68
          },
          end: {
            line: 79,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 68
          },
          end: {
            line: 79,
            column: 84
          }
        }, {
          start: {
            line: 79,
            column: 89
          },
          end: {
            line: 79,
            column: 98
          }
        }],
        line: 79
      },
      "10": {
        loc: {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 106
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 106
          }
        }, {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 106
          }
        }],
        line: 80
      },
      "11": {
        loc: {
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 80,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 80,
            column: 44
          }
        }, {
          start: {
            line: 80,
            column: 48
          },
          end: {
            line: 80,
            column: 69
          }
        }],
        line: 80
      },
      "12": {
        loc: {
          start: {
            line: 86,
            column: 11
          },
          end: {
            line: 86,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 34
          },
          end: {
            line: 86,
            column: 51
          }
        }, {
          start: {
            line: 86,
            column: 54
          },
          end: {
            line: 86,
            column: 60
          }
        }],
        line: 86
      },
      "13": {
        loc: {
          start: {
            line: 91,
            column: 21
          },
          end: {
            line: 91,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 21
          },
          end: {
            line: 91,
            column: 40
          }
        }, {
          start: {
            line: 91,
            column: 44
          },
          end: {
            line: 91,
            column: 70
          }
        }],
        line: 91
      },
      "14": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        }],
        line: 92
      },
      "15": {
        loc: {
          start: {
            line: 96,
            column: 34
          },
          end: {
            line: 96,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 34
          },
          end: {
            line: 96,
            column: 42
          }
        }, {
          start: {
            line: 96,
            column: 46
          },
          end: {
            line: 96,
            column: 71
          }
        }],
        line: 96
      },
      "16": {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 40
          }
        }, {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 40
          }
        }],
        line: 101
      },
      "17": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        }],
        line: 133
      },
      "18": {
        loc: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }, {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }],
        line: 138
      },
      "19": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }],
        line: 147
      },
      "20": {
        loc: {
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 147,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 147,
            column: 17
          }
        }, {
          start: {
            line: 147,
            column: 21
          },
          end: {
            line: 147,
            column: 29
          }
        }],
        line: 147
      },
      "21": {
        loc: {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }, {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }],
        line: 152
      },
      "22": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 39
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 39
          }
        }],
        line: 157
      },
      "23": {
        loc: {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 164,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 164,
            column: 35
          }
        }, {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 164,
            column: 35
          }
        }],
        line: 164
      },
      "24": {
        loc: {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 16
          }
        }, {
          start: {
            line: 164,
            column: 20
          },
          end: {
            line: 164,
            column: 27
          }
        }],
        line: 164
      },
      "25": {
        loc: {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 178,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 178,
            column: 9
          }
        }, {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 178,
            column: 9
          }
        }],
        line: 172
      },
      "26": {
        loc: {
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 192,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 192,
            column: 9
          }
        }, {
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 192,
            column: 9
          }
        }],
        line: 183
      },
      "27": {
        loc: {
          start: {
            line: 185,
            column: 15
          },
          end: {
            line: 192,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 15
          },
          end: {
            line: 192,
            column: 9
          }
        }, {
          start: {
            line: 185,
            column: 15
          },
          end: {
            line: 192,
            column: 9
          }
        }],
        line: 185
      },
      "28": {
        loc: {
          start: {
            line: 188,
            column: 10
          },
          end: {
            line: 190,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 188,
            column: 10
          },
          end: {
            line: 190,
            column: 11
          }
        }, {
          start: {
            line: 188,
            column: 10
          },
          end: {
            line: 190,
            column: 11
          }
        }],
        line: 188
      },
      "29": {
        loc: {
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 205,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 205,
            column: 7
          }
        }, {
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 205,
            column: 7
          }
        }],
        line: 195
      },
      "30": {
        loc: {
          start: {
            line: 197,
            column: 8
          },
          end: {
            line: 197,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 8
          },
          end: {
            line: 197,
            column: 71
          }
        }, {
          start: {
            line: 197,
            column: 8
          },
          end: {
            line: 197,
            column: 71
          }
        }],
        line: 197
      },
      "31": {
        loc: {
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 201,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 201,
            column: 44
          }
        }, {
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 201,
            column: 44
          }
        }],
        line: 201
      },
      "32": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        }, {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        }],
        line: 209
      },
      "33": {
        loc: {
          start: {
            line: 229,
            column: 6
          },
          end: {
            line: 229,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 229,
            column: 13
          },
          end: {
            line: 229,
            column: 30
          }
        }],
        line: 229
      },
      "34": {
        loc: {
          start: {
            line: 235,
            column: 6
          },
          end: {
            line: 235,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 235,
            column: 23
          },
          end: {
            line: 235,
            column: 50
          }
        }],
        line: 235
      },
      "35": {
        loc: {
          start: {
            line: 245,
            column: 21
          },
          end: {
            line: 245,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 245,
            column: 32
          },
          end: {
            line: 245,
            column: 49
          }
        }, {
          start: {
            line: 245,
            column: 52
          },
          end: {
            line: 245,
            column: 61
          }
        }],
        line: 245
      },
      "36": {
        loc: {
          start: {
            line: 252,
            column: 18
          },
          end: {
            line: 252,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 252,
            column: 18
          },
          end: {
            line: 252,
            column: 48
          }
        }, {
          start: {
            line: 252,
            column: 52
          },
          end: {
            line: 252,
            column: 62
          }
        }],
        line: 252
      },
      "37": {
        loc: {
          start: {
            line: 261,
            column: 16
          },
          end: {
            line: 261,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 261,
            column: 16
          },
          end: {
            line: 261,
            column: 22
          }
        }, {
          start: {
            line: 261,
            column: 26
          },
          end: {
            line: 261,
            column: 41
          }
        }],
        line: 261
      },
      "38": {
        loc: {
          start: {
            line: 270,
            column: 27
          },
          end: {
            line: 270,
            column: 117
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 270,
            column: 69
          },
          end: {
            line: 270,
            column: 86
          }
        }, {
          start: {
            line: 270,
            column: 89
          },
          end: {
            line: 270,
            column: 117
          }
        }],
        line: 270
      },
      "39": {
        loc: {
          start: {
            line: 271,
            column: 23
          },
          end: {
            line: 271,
            column: 100
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 271,
            column: 61
          },
          end: {
            line: 271,
            column: 74
          }
        }, {
          start: {
            line: 271,
            column: 77
          },
          end: {
            line: 271,
            column: 100
          }
        }],
        line: 271
      },
      "40": {
        loc: {
          start: {
            line: 272,
            column: 19
          },
          end: {
            line: 272,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 272,
            column: 53
          },
          end: {
            line: 272,
            column: 62
          }
        }, {
          start: {
            line: 272,
            column: 65
          },
          end: {
            line: 272,
            column: 85
          }
        }],
        line: 272
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0],
      "34": [0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tree/Tree.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import DatumTree from '../Datum/Tree';
import Root from './Root';
import { deepClone } from '../utils/clone';
var DefaultProps = (cov_1283wwoyq.s[0]++, {
  data: [],
  defaultExpanded: [],
  defaultValue: [],
  mode: 0,
  dataUpdate: true,
  childrenKey: 'children',
  dragImageStyle: {}
});

var Tree =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tree, _PureComponent);

  var _super = _createSuper2(Tree);

  function Tree(props) {
    var _this;

    _classCallCheck(this, Tree);

    cov_1283wwoyq.f[0]++;
    cov_1283wwoyq.s[1]++;
    _this = _super.call(this, props);
    _this.handleDragImageSelector = void 0;
    _this.handleClidrenClass = void 0;
    _this.handleLeafClass = void 0;
    _this.nodes = void 0;
    _this.datum = void 0;
    cov_1283wwoyq.s[2]++;
    _this.state = {
      active: null
    };
    cov_1283wwoyq.s[3]++;
    _this.nodes = new Map();
    cov_1283wwoyq.s[4]++;
    _this.datum = (cov_1283wwoyq.b[0][0]++, props.datum) || (cov_1283wwoyq.b[0][1]++, new DatumTree({
      data: props.data,
      loader: props.loader,
      keygen: props.keygen,
      mode: props.mode,
      onChange: props.onChange,
      value: (cov_1283wwoyq.b[1][0]++, props.value) || (cov_1283wwoyq.b[1][1]++, props.defaultValue),
      disabled: typeof props.disabled === 'function' ? (cov_1283wwoyq.b[2][0]++, props.disabled) : (cov_1283wwoyq.b[2][1]++, undefined),
      childrenKey: (cov_1283wwoyq.b[3][0]++, props.childrenKey) || (cov_1283wwoyq.b[3][1]++, DefaultProps.childrenKey),
      unmatch: props.unmatch
    }));
    cov_1283wwoyq.s[5]++;
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized(_this));
    cov_1283wwoyq.s[6]++;
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    cov_1283wwoyq.s[7]++;
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_this));
    cov_1283wwoyq.s[8]++;
    _this.bindNode = _this.bindNode.bind(_assertThisInitialized(_this));
    cov_1283wwoyq.s[9]++;
    _this.getNodeInitState = _this.getNodeInitState.bind(_assertThisInitialized(_this));
    cov_1283wwoyq.s[10]++;
    _this.unbindNode = _this.unbindNode.bind(_assertThisInitialized(_this));
    cov_1283wwoyq.s[11]++;
    _this.handleDragImageSelector = _this.handleProps.bind(_assertThisInitialized(_this), 'dragImageSelector');
    cov_1283wwoyq.s[12]++;
    _this.handleClidrenClass = _this.handleProps.bind(_assertThisInitialized(_this), 'childrenClass');
    cov_1283wwoyq.s[13]++;
    _this.handleLeafClass = _this.handleProps.bind(_assertThisInitialized(_this), 'leafClass');
    cov_1283wwoyq.s[14]++;

    _this.bindDatum();

    return _this;
  }

  _createClass(Tree, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_1283wwoyq.f[1]++;
      cov_1283wwoyq.s[15]++;

      if (prevProps.expanded !== this.props.expanded) {
        cov_1283wwoyq.b[4][0]++;
        cov_1283wwoyq.s[16]++;
        this.handleExpanded(this.props.expanded);
      } else {
        cov_1283wwoyq.b[4][1]++;
      }

      cov_1283wwoyq.s[17]++;

      if (prevProps.active !== this.props.active) {
        cov_1283wwoyq.b[5][0]++;
        cov_1283wwoyq.s[18]++;
        this.handleActive(this.props.active);
      } else {
        cov_1283wwoyq.b[5][1]++;
      }

      cov_1283wwoyq.s[19]++;

      if ((cov_1283wwoyq.b[7][0]++, this.props.onChange) || (cov_1283wwoyq.b[7][1]++, this.props.onDrop) || (cov_1283wwoyq.b[7][2]++, this.props.radioUpdate)) {
        cov_1283wwoyq.b[6][0]++;
        cov_1283wwoyq.s[20]++;
        this.datum.mode = this.props.mode;
        cov_1283wwoyq.s[21]++;

        if (prevProps.value !== this.props.value) {
          cov_1283wwoyq.b[8][0]++;
          cov_1283wwoyq.s[22]++;
          this.datum.setValue((cov_1283wwoyq.b[9][0]++, this.props.value) || (cov_1283wwoyq.b[9][1]++, []));
        } else {
          cov_1283wwoyq.b[8][1]++;
        }

        cov_1283wwoyq.s[23]++;

        if ((cov_1283wwoyq.b[11][0]++, prevProps.data !== this.props.data) && (cov_1283wwoyq.b[11][1]++, this.props.dataUpdate)) {
          cov_1283wwoyq.b[10][0]++;
          cov_1283wwoyq.s[24]++;
          this.datum.setData(this.props.data);
        } else {
          cov_1283wwoyq.b[10][1]++;
        }
      } else {
        cov_1283wwoyq.b[6][1]++;
      }
    }
  }, {
    key: "getActive",
    value: function getActive() {
      cov_1283wwoyq.f[2]++;

      var _ref = (cov_1283wwoyq.s[25]++, this.props),
          active = _ref.active;

      cov_1283wwoyq.s[26]++;
      return active === undefined ? (cov_1283wwoyq.b[12][0]++, this.state.active) : (cov_1283wwoyq.b[12][1]++, active);
    }
  }, {
    key: "getNodeInitState",
    value: function getNodeInitState(id) {
      cov_1283wwoyq.f[3]++;
      var active = (cov_1283wwoyq.s[27]++, this.props.active === id);
      var expanded = (cov_1283wwoyq.s[28]++, (cov_1283wwoyq.b[13][0]++, this.props.expanded) || (cov_1283wwoyq.b[13][1]++, this.props.defaultExpanded));
      cov_1283wwoyq.s[29]++;

      if (this.props.defaultExpandAll) {
        cov_1283wwoyq.b[14][0]++;
        cov_1283wwoyq.s[30]++;
        return {
          active: active,
          expanded: true
        };
      } else {
        cov_1283wwoyq.b[14][1]++;
      }

      cov_1283wwoyq.s[31]++;
      return {
        active: active,
        expanded: !!((cov_1283wwoyq.b[15][0]++, expanded) && (cov_1283wwoyq.b[15][1]++, expanded.indexOf(id) >= 0))
      };
    }
  }, {
    key: "bindDatum",
    value: function bindDatum() {
      cov_1283wwoyq.f[4]++;

      var _ref2 = (cov_1283wwoyq.s[32]++, this.props),
          bindDatum = _ref2.bindDatum;

      cov_1283wwoyq.s[33]++;

      if (bindDatum) {
        cov_1283wwoyq.b[16][0]++;
        cov_1283wwoyq.s[34]++;
        bindDatum(this.datum);
      } else {
        cov_1283wwoyq.b[16][1]++;
      }
    }
  }, {
    key: "bindNode",
    value: function bindNode(id, update) {
      cov_1283wwoyq.f[5]++;
      cov_1283wwoyq.s[35]++;

      /*
      if (this.nodes.has(id)) {
        console.error(`Node with '${id}' key has already been added. Tree node's key must be unique.`)
        return {}
      }
      */
      this.nodes.set(id, update);
    }
  }, {
    key: "unbindNode",
    value: function unbindNode(id) {
      cov_1283wwoyq.f[6]++;
      cov_1283wwoyq.s[36]++;
      this.nodes["delete"](id);
    }
  }, {
    key: "handleExpanded",
    value: function handleExpanded(expanded) {
      cov_1283wwoyq.f[7]++;
      var temp = (cov_1283wwoyq.s[37]++, new Set(expanded));
      cov_1283wwoyq.s[38]++;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              id = _step$value[0],
              update = _step$value[1];

          cov_1283wwoyq.s[39]++;
          update('expanded', temp.has(id));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "handleActive",
    value: function handleActive(active) {
      cov_1283wwoyq.f[8]++;
      cov_1283wwoyq.s[40]++;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.nodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              id = _step2$value[0],
              update = _step2$value[1];

          cov_1283wwoyq.s[41]++;
          update('active', id === active);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "handleNodeClick",
    value: function handleNodeClick(node, id) {
      var _this2 = this;

      cov_1283wwoyq.f[9]++;

      var _ref3 = (cov_1283wwoyq.s[42]++, this.props),
          active = _ref3.active,
          onClick = _ref3.onClick;

      cov_1283wwoyq.s[43]++;

      if (active === undefined) {
        cov_1283wwoyq.b[17][0]++;
        cov_1283wwoyq.s[44]++;
        this.setState({
          active: id
        }, function () {
          cov_1283wwoyq.f[10]++;
          cov_1283wwoyq.s[45]++;

          _this2.handleActive(id);
        });
      } else {
        cov_1283wwoyq.b[17][1]++;
      }

      cov_1283wwoyq.s[46]++;

      if (onClick) {
        cov_1283wwoyq.b[18][0]++;
        cov_1283wwoyq.s[47]++;
        onClick(node, id, this.datum.getPath(id));
      } else {
        cov_1283wwoyq.b[18][1]++;
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(id) {
      cov_1283wwoyq.f[11]++;

      var _ref4 = (cov_1283wwoyq.s[48]++, this.props),
          expanded = _ref4.expanded,
          onExpand = _ref4.onExpand;

      var newExpanded;
      cov_1283wwoyq.s[49]++;

      if ((cov_1283wwoyq.b[20][0]++, !expanded) && (cov_1283wwoyq.b[20][1]++, onExpand)) {
        cov_1283wwoyq.b[19][0]++;
        cov_1283wwoyq.s[50]++;
        onExpand([id]);
        cov_1283wwoyq.s[51]++;
        return;
      } else {
        cov_1283wwoyq.b[19][1]++;
      }

      var expandedArr = (cov_1283wwoyq.s[52]++, expanded);
      cov_1283wwoyq.s[53]++;

      if (expandedArr.indexOf(id) >= 0) {
        cov_1283wwoyq.b[21][0]++;
        cov_1283wwoyq.s[54]++;
        newExpanded = expandedArr.filter(function (e) {
          cov_1283wwoyq.f[12]++;
          cov_1283wwoyq.s[55]++;
          return e !== id;
        });
      } else {
        cov_1283wwoyq.b[21][1]++;
        cov_1283wwoyq.s[56]++;
        newExpanded = [].concat(_toConsumableArray(expandedArr), [id]);
      }

      cov_1283wwoyq.s[57]++;

      if (onExpand) {
        cov_1283wwoyq.b[22][0]++;
        cov_1283wwoyq.s[58]++;
        onExpand(newExpanded);
      } else {
        cov_1283wwoyq.b[22][1]++;
      }
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(id, targetId, position) {
      var _this3 = this;

      cov_1283wwoyq.f[13]++;

      var _ref5 = (cov_1283wwoyq.s[59]++, this.props),
          childrenKey = _ref5.childrenKey;

      var current = (cov_1283wwoyq.s[60]++, this.datum.getPath(id));
      var target = (cov_1283wwoyq.s[61]++, this.datum.getPath(targetId));
      cov_1283wwoyq.s[62]++;

      if ((cov_1283wwoyq.b[24][0]++, !current) || (cov_1283wwoyq.b[24][1]++, !target)) {
        cov_1283wwoyq.b[23][0]++;
        cov_1283wwoyq.s[63]++;
        return;
      } else {
        cov_1283wwoyq.b[23][1]++;
      }

      var cloneData = (cov_1283wwoyq.s[64]++, deepClone(this.props.data));
      var data = (cov_1283wwoyq.s[65]++, immer(cloneData, function (draft) {
        cov_1283wwoyq.f[14]++;
        var node = (cov_1283wwoyq.s[66]++, draft);
        var temp;
        cov_1283wwoyq.s[67]++;

        var removeNode = function removeNode() {
          cov_1283wwoyq.f[15]++;
        };

        var offset = (cov_1283wwoyq.s[68]++, 0);
        cov_1283wwoyq.s[69]++;
        current.indexPath.forEach(function (p, i) {
          cov_1283wwoyq.f[16]++;
          cov_1283wwoyq.s[70]++;

          if (i < current.indexPath.length - 1) {
            cov_1283wwoyq.b[25][0]++;
            cov_1283wwoyq.s[71]++;
            node = node[p][childrenKey];
          } else {
            cov_1283wwoyq.b[25][1]++;
            cov_1283wwoyq.s[72]++;
            temp = node;
            cov_1283wwoyq.s[73]++;

            removeNode = function removeNode() {
              cov_1283wwoyq.f[17]++;
              cov_1283wwoyq.s[74]++;
              return temp.splice(p, 1)[0];
            };

            cov_1283wwoyq.s[75]++;
            node = node[p];
          }
        });
        var tnode = (cov_1283wwoyq.s[76]++, draft);
        cov_1283wwoyq.s[77]++;
        target.indexPath.forEach(function (p, i) {
          cov_1283wwoyq.f[18]++;
          cov_1283wwoyq.s[78]++;

          if (i < target.indexPath.length - 1) {
            cov_1283wwoyq.b[26][0]++;
            cov_1283wwoyq.s[79]++;
            tnode = tnode[p][childrenKey];
          } else {
            cov_1283wwoyq.b[26][1]++;
            cov_1283wwoyq.s[80]++;

            if (tnode === temp) {
              cov_1283wwoyq.b[27][0]++;
              cov_1283wwoyq.s[81]++;
              // same parent
              removeNode();
              cov_1283wwoyq.s[82]++;

              if (current.index <= target.index) {
                cov_1283wwoyq.b[28][0]++;
                cov_1283wwoyq.s[83]++;
                offset = -1;
              } else {
                cov_1283wwoyq.b[28][1]++;
              }

              cov_1283wwoyq.s[84]++;

              removeNode = function removeNode() {
                cov_1283wwoyq.f[19]++;
              };
            } else {
              cov_1283wwoyq.b[27][1]++;
            }
          }
        });
        cov_1283wwoyq.s[85]++;

        if (position === -1) {
          cov_1283wwoyq.b[29][0]++;
          cov_1283wwoyq.s[86]++;
          tnode = tnode[target.index + offset];
          cov_1283wwoyq.s[87]++;

          if (!Array.isArray(tnode[childrenKey])) {
            cov_1283wwoyq.b[30][0]++;
            cov_1283wwoyq.s[88]++;
            tnode[childrenKey] = [];
          } else {
            cov_1283wwoyq.b[30][1]++;
          }

          cov_1283wwoyq.s[89]++;
          tnode[childrenKey].push(node);
          cov_1283wwoyq.s[90]++;
          position = tnode[childrenKey].length - 1;
          var update = (cov_1283wwoyq.s[91]++, _this3.nodes.get(targetId));
          cov_1283wwoyq.s[92]++;

          if (update) {
            cov_1283wwoyq.b[31][0]++;
            cov_1283wwoyq.s[93]++;
            update('expanded', true);
          } else {
            cov_1283wwoyq.b[31][1]++;
          }
        } else {
          cov_1283wwoyq.b[29][1]++;
          cov_1283wwoyq.s[94]++;
          tnode.splice(position + offset, 0, node);
          cov_1283wwoyq.s[95]++;
          targetId = target.path[target.path.length - 1];
        }

        cov_1283wwoyq.s[96]++;
        removeNode();
      }));
      cov_1283wwoyq.s[97]++;

      if (this.props.onDrop) {
        cov_1283wwoyq.b[32][0]++;
        cov_1283wwoyq.s[98]++;
        this.props.onDrop(data, id, targetId, position);
      } else {
        cov_1283wwoyq.b[32][1]++;
      }
    }
  }, {
    key: "handleProps",
    value: function handleProps(key) {
      cov_1283wwoyq.f[20]++;
      cov_1283wwoyq.s[99]++;
      return this.props[key];
    }
  }, {
    key: "render",
    value: function render() {
      cov_1283wwoyq.f[21]++;

      var _ref6 = (cov_1283wwoyq.s[100]++, this.props),
          className = _ref6.className,
          style = _ref6.style,
          data = _ref6.data,
          disabled = _ref6.disabled,
          line = _ref6.line,
          keygen = _ref6.keygen,
          onExpand = _ref6.onExpand,
          onChange = _ref6.onChange,
          renderItem = _ref6.renderItem,
          _ref6$mode = _ref6.mode,
          mode = _ref6$mode === void 0 ? (cov_1283wwoyq.b[33][0]++, DefaultProps.mode) : _ref6$mode,
          onDrop = _ref6.onDrop,
          loader = _ref6.loader,
          parentClickExpand = _ref6.parentClickExpand,
          childrenKey = _ref6.childrenKey,
          expandIcons = _ref6.expandIcons,
          _ref6$dragImageStyle = _ref6.dragImageStyle,
          dragImageStyle = _ref6$dragImageStyle === void 0 ? (cov_1283wwoyq.b[34][0]++, DefaultProps.dragImageStyle) : _ref6$dragImageStyle,
          dragImageSelector = _ref6.dragImageSelector,
          childrenClass = _ref6.childrenClass,
          leafClass = _ref6.leafClass,
          dragHoverExpand = _ref6.dragHoverExpand,
          doubleClickExpand = _ref6.doubleClickExpand,
          iconClass = _ref6.iconClass,
          nodeClass = _ref6.nodeClass,
          dragSibling = _ref6.dragSibling;

      var onToggle = (cov_1283wwoyq.s[101]++, onExpand ? (cov_1283wwoyq.b[35][0]++, this.handleToggle) : (cov_1283wwoyq.b[35][1]++, undefined));
      cov_1283wwoyq.s[102]++;
      return (
        /*#__PURE__*/
        React.createElement(Root, {
          className: className,
          data: data,
          datum: this.datum,
          disabled: (cov_1283wwoyq.b[36][0]++, typeof disabled !== 'function') && (cov_1283wwoyq.b[36][1]++, !!disabled),
          bindNode: this.bindNode,
          getNodeInitState: this.getNodeInitState,
          keygen: keygen,
          line: line,
          loader: loader,
          mode: mode,
          unbindNode: this.unbindNode,
          onChange: onChange,
          onDrop: (cov_1283wwoyq.b[37][0]++, onDrop) && (cov_1283wwoyq.b[37][1]++, this.handleDrop),
          onToggle: onToggle,
          onNodeClick: this.handleNodeClick,
          renderItem: renderItem,
          style: style,
          parentClickExpand: parentClickExpand,
          childrenKey: childrenKey,
          expandIcons: expandIcons,
          dragImageStyle: dragImageStyle,
          dragImageSelector: typeof dragImageSelector === 'function' ? (cov_1283wwoyq.b[38][0]++, dragImageSelector) : (cov_1283wwoyq.b[38][1]++, this.handleDragImageSelector),
          childrenClass: typeof childrenClass === 'function' ? (cov_1283wwoyq.b[39][0]++, childrenClass) : (cov_1283wwoyq.b[39][1]++, this.handleClidrenClass),
          leafClass: typeof leafClass === 'function' ? (cov_1283wwoyq.b[40][0]++, leafClass) : (cov_1283wwoyq.b[40][1]++, this.handleLeafClass),
          dragHoverExpand: dragHoverExpand,
          doubleClickExpand: doubleClickExpand,
          iconClass: iconClass,
          nodeClass: nodeClass,
          dragSibling: dragSibling,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 248,
            columnNumber: 7
          }
        })
      );
    }
  }]);

  return Tree;
}(PureComponent);

Tree.defaultProps = DefaultProps;
export default Tree;